import { Dict, Guard } from '../types';

const object = (x: unknown): x is Dict<string, unknown> =>
    typeof x === 'object' && x != null;
const string = (x: unknown): x is string => typeof x === 'string';

const number = (x: unknown): x is number =>
    typeof x === 'number' && !Number.isNaN(x);

const boolean = (x: unknown): x is boolean => typeof x === 'boolean';

const array = (x: unknown): x is Array<unknown> => Array.isArray(x);

const arrayOf = <T>(x: unknown, guard: Guard<unknown, T>): x is T[] => {
    if (!array(x)) return false;

    return x.every(guard);
};

const ofEnum = <T extends object>(x: unknown, anEnum: T): x is T[keyof T] =>
    Object.values(anEnum).includes(x);

const notUndefined = <T>(x: T | undefined): x is T => typeof x !== 'undefined';

const propsOfType = <T>(
    x: unknown,
    props: string[],
    guard: Guard<unknown, T>,
): boolean => object(x) && props.every((p) => guard(x[p]));

const nullObjectResponse = (x: unknown): x is Record<string, never> =>
    object(x) && Object.keys(x).length === 0;

const typeOrNull = <T>(x: unknown, guard: (x: unknown) => x is T | null) => {
    if (typeof x === 'undefined' || x === null) return true;
    return guard(x);
};

/* --------------------------------- Export --------------------------------- */

export const is = {
    object,
    string,
    number,
    boolean,
    array,
    arrayOf,
    ofEnum,
    notUndefined,
    propsOfType,
    nullObjectResponse,
    typeOrNull,
};
